var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationDestinationIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28775 0C12.9213 0 15.8778 2.99693 15.8778 6.67981C15.8778 10.5143 12.0827 15.4141 10.0627 17.5424C9.63335 17.9948 8.93862 18.0006 8.50687 17.5505C6.48359 15.441 2.69922 10.5103 2.69922 6.67981C2.69922 2.99673 5.65442 0 9.28775 0ZM9.2885 3.66071C10.9043 3.66071 12.2171 4.97603 12.2171 6.5909C12.2171 8.20578 10.9043 9.51785 9.2885 9.51785C7.67272 9.51785 6.35993 8.20578 6.35993 6.5909C6.35993 4.97278 7.67272 3.66071 9.2885 3.66071Z",
    fill: "#334B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDestinationIconDark);
export default __webpack_public_path__ + "static/media/location_destination_icon_dark.a19ad93f59d1986825953bba5864c641.svg";
export { ForwardRef as ReactComponent };